import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
import { FormLabel } from '@mui/material';
import { useProyecto } from '../../data/ProyectoContext';

const Input = styled(MuiInput)`
  width: 42px;
  
`;

export default function DuracionSesiones({max}) {
    const [value, setValue] = React.useState(1);
    const { proyecto, setProyecto } = useProyecto();


    const handleHorasSemanaChange = (nuevaCantidadHorasSemanas) => {
        setProyecto({...proyecto, No_sesiones: nuevaCantidadHorasSemanas });
      };

      
    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
        handleHorasSemanaChange(newValue);
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? 1 : Number(event.target.value));
        handleHorasSemanaChange(Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 1) {
            setValue(1);
        } else if (value > 30) {
            setValue(30);
        }
    };

    return (
        <Box sx={{ width: '90%', ml:2 }}>

            <Box sx={{ display: 'flex', flexDirection: 'column', pb: 1 }}>
                <Typography sx={{ fontFamily: 'Montserrat', fontSize: '1.25rem',  color: '#336B87', fontWeight: 'bold' }}>Número de sesiones *</Typography>
                <FormLabel component="p" sx={{ fontFamily: 'Montserrat', fontSize: '0.85rem', mt: 0.2 }}>Selecciona el total de sesiones que se dedicará cada semana a la implementación 
                de esta planificación. (bloques de 90 minutos por sesión)</FormLabel>
            </Box>

            <Grid container spacing={2} >

                <Grid item xs>
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        color="success"
                        sx={{
                            ml:2,
                            width:'95%',
                            color: '#336B87',
                            '& .MuiSlider-markLabel': {
                                color: '#336B87',
                                fontFamily: 'montserrat',
                            },
                            '& .MuiSlider-valueLabel': {
                                backgroundColor: '#F9DA96',
                                color: '#209099',
                                fontFamily: 'montserrat'
                            },
                        }}
                        valueLabelDisplay="auto"
                        defaultValue={max}
                        min={1}
                        max={max}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize:'0.62rem', color:'rgba(0, 0, 0, 0.6)' }}
                        >
                            1 sesión
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize:'0.62rem', color:'rgba(0, 0, 0, 0.6)' }}
                        >
                            8 sesiones
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Input
                        value={value}
                        size="small"
                        
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 1,
                            min: 1,
                            max: max,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}